<template>
    <span>
        {{ message }} <i class="fas fa-spinner fa-spin"></i>
    </span>
</template>
<script>
export default {
  name: 'loading',
  props: ['message']
}
</script>
